import React from "react";
import { Box, Card, Collapse } from "@mui/material";
import fingerprint from "@iconify/icons-mdi/fingerprint";
import { InlineIcon } from "@iconify/react";
import { MyHrCollapseLabel, MyHrContract } from "my-hr/components";
import { OcAvatar } from "oc/components";
import { useOcClientState } from "oc/hooks";
import { getFullname } from "oc/utils";

interface MyHrDataCollapseProps {
  id?: string;
  employee: any; // Replace 'any' with the actual employee type if available
  contractsData: any[]; // Replace 'any' with the actual contract type if available
  isMobile: boolean;
}

export const MyHrDataCollapse: React.FC<MyHrDataCollapseProps> = ({
  id,
  employee,
  contractsData,
  isMobile,
}) => {
  let stateId = id || "addPermissionCollapseState";

  const [expanded, setExpanded] = useOcClientState<boolean>(stateId, false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: "4px",
        borderColor: "white",
      }}
      variant="outlined"
    >
      <MyHrCollapseLabel
        expanded={expanded}
        handleExpandClick={handleExpandClick}
        name={getFullname(employee) ?? ""}
        code={employee?.code}
      />
      <Collapse
        in={expanded}
        timeout="auto"
        unmountOnExit
        style={{ marginBottom: "18px" }}
      >
        <Box padding="0px 16px">
          <Box style={{ borderTop: "2px solid #C6CACC" }}>
            {isMobile && <Box height="16px" />}
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              <Box padding="16px">
                <OcAvatar
                  employee={employee?.code}
                  style={{
                    width: "75px",
                    height: "75px",
                    marginRight: "32px",
                  }}
                />
              </Box>
              <Box
                height={isMobile ? "100%" : "75px"}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Box fontSize="34px" letterSpacing="0.25px">
                  {getFullname(employee)}
                </Box>
                {isMobile && <Box height="16px" />}
                <Box display="flex" flexDirection="row">
                  <Box marginRight="8px">
                    <InlineIcon icon={fingerprint} width="16px" height="16px" />
                  </Box>
                  <Box>{employee?.code}</Box>
                </Box>
              </Box>
            </Box>
            {isMobile && <Box height="16px" />}
          </Box>
        </Box>
        {contractsData?.map((item, index) => {
          return (
            <MyHrContract
              key={`${index}-${item.code}`}
              contract={item}
              isMobile={isMobile}
            />
          );
        })}
      </Collapse>
    </Card>
  );
};

export default MyHrDataCollapse;
